import { Col, Empty, Row, Spin } from 'antd';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { dateFromNow, formatMoney } from 'utils/textUtils';
import { JobCardStyles, SectionStyles } from '../styles';

function JobList({ jobs, loading, basePath }) {
  const path = basePath || '';

  return (
    <SectionStyles id="jobs" className="section-jobs">
      <div className="section-inner">
        <h2 className="section-title">Việc làm đang tuyển</h2>
        {loading ? (
          <div className="section-loading">
            <Spin size="large" />
          </div>
        ) : !jobs?.length ? (
          <Empty description="Chưa có tin tuyển dụng nào." />
        ) : (
          <Row gutter={[16, 16]}>
            {jobs.map((record) => (
              <Col xs={24} sm={24} md={12} lg={12} key={record.id}>
                <Link
                  to={`/recruitments/${record.id}/show`}
                  className="job-card-link"
                >
                  <JobCardStyles className="job-card-public">
                    <div className="job-card-title">{record.header}</div>
                    <div className="job-card-meta">
                      <span className="job-card-company">
                        {record.company?.name}
                      </span>
                    </div>
                    {record.city && (
                      <div className="job-card-address">{record.city}</div>
                    )}
                    <div className="job-card-salary">
                      <img
                        className="salary-icon"
                        src="/icons/salary.png"
                        alt=""
                      />
                      <span>
                        {record.minSalary !== record.maxSalary && record.maxSalary
                          ? `${formatMoney(record.minSalary)} - ${formatMoney(record.maxSalary)}${record.salaryKpi ? ` + KPI: ${record.salaryKpi}` : ''}`
                          : `${formatMoney(record.minSalary)}${record.salaryKpi ? ` + KPI: ${record.salaryKpi}` : ''}`}
                      </span>
                    </div>
                    <div className="job-card-time">
                      <span>{dateFromNow(record.createdAt)}</span>
                      <span className="job-card-more">Xem thêm →</span>
                    </div>
                  </JobCardStyles>
                </Link>
              </Col>
            ))}
          </Row>
        )}
      </div>
    </SectionStyles>
  );
}

JobList.propTypes = {
  jobs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      header: PropTypes.string,
      city: PropTypes.string,
      minSalary: PropTypes.number,
      maxSalary: PropTypes.number,
      salaryKpi: PropTypes.string,
      createdAt: PropTypes.string,
      company: PropTypes.shape({ name: PropTypes.string }),
    }),
  ),
  loading: PropTypes.bool,
  basePath: PropTypes.string,
};

JobList.defaultProps = {
  jobs: [],
  loading: false,
  basePath: '',
};

export default JobList;
